import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.3331 2.58311C11.7473 2.58311 12.0831 2.9189 12.0831 3.33311C12.0831 3.74733 11.7473 4.08311 11.3331 4.08311H9.8989L7.66075 11.9166H8.6665C9.08072 11.9166 9.4165 12.2524 9.4165 12.6666C9.4165 13.0808 9.08072 13.4166 8.6665 13.4166C8.66202 13.4167 4.6665 13.4166 4.6665 13.4166C4.25229 13.4166 3.9165 13.0808 3.9165 12.6666C3.9165 12.2524 4.25229 11.9166 4.6665 11.9166H6.10073L8.33887 4.08311H7.33313C6.91892 4.08311 6.58313 3.74733 6.58313 3.33311C6.58313 2.9189 6.91892 2.58311 7.33313 2.58311H11.3331Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }